import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireSpace } from '@/lib/guards'

/** Le placeur n'a qu'un seul écran : pas de barre d'onglets. */
export const Route = createFileRoute('/_placeur')({
  beforeLoad: () => requireSpace('/scanner'),
  component: () => <Outlet />,
})
